import { Axios } from 'axios';
import { CONTROLLER_API_PREFIX, UNI_API_CONTROLLER } from 'app/constants';
import { FALLBACK_ROW, type EditorialTileRow } from 'app/domain';

class EditorialTilesService {
  readonly #httpClient: Axios;
  readonly #baseUrl: string;

  constructor(httpClient: Axios) {
    this.#httpClient = httpClient;
    this.#baseUrl = `/${CONTROLLER_API_PREFIX}/${UNI_API_CONTROLLER.editorialTiles}`;
  }

  // A failed request gives the fallback row instead of throwing, so a server
  // render keeps the rest of the page.
  async getRow(
    page: string,
    previewIds: readonly string[] = []
  ): Promise<EditorialTileRow> {
    try {
      const response = await this.#httpClient.get<EditorialTileRow>(
        this.#baseUrl,
        {
          params: {
            page,
            ...(previewIds.length > 0 && { previewIds: previewIds.join(',') }),
          },
        }
      );
      return response.data;
    } catch {
      return FALLBACK_ROW;
    }
  }
}

export default EditorialTilesService;
